import React from "react";
import { createRoot } from "react-dom/client";  // New import
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";

// Get the root DOM element
const container = document.getElementById("root");

// Create a root using the new API
const root = createRoot(container);

// Render the app using the new API
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
